function MilliMucadele() {
  const iframeSrc = "/milli-mucadelenin-yuzuncu-yili/index.html";
  return (
    <section className="section-box">
      <iframe src={iframeSrc} border="0" width="100%" height="600"></iframe>
    </section>
  );
}

export default MilliMucadele;
